import ApiService from "@/core/services/ApiService";

class functionService {

    public static update(id, data){
        ApiService.setHeader()
        return ApiService.put(`api/functions/${id}/update`,data)
    }

    public static delete(target: string, id:string,){
        ApiService.setHeader()
        return ApiService.delete(`api/${target}/${id}`, 'delete')
    }

    public static getOptions(resource, slug){
        ApiService.setHeader()
        return ApiService.get(resource, slug)
    }

    public static postOptions(resource: string, params: any){
        ApiService.setHeader()
        return ApiService.post(`api/functions/${resource}`, params)
    }

}

export default functionService;